import styles from "./FlagIcon.module.css";

const flagPaths = {
  ve: (
    <>
      <rect
        fill="#FFCE00"
        width="30"
        height="6.67"
      />
      <rect
        fill="#00247D"
        y="6.67"
        width="30"
        height="6.67"
      />
      <rect
        fill="#CF142B"
        y="13.34"
        width="30"
        height="6.66"
      />
      <g fill="#FFF">
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(7, 11.2)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(9.3, 10.2)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(11.5, 9.5)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(13.3, 9.1)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(16.7, 9.1)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(18.5, 9.5)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(20.7, 10.2)"
        />
        <polygon
          points="0,-0.7 0.17,-0.22 0.67,-0.22 0.25,0.08 0.41,0.57 0,0.27 -0.41,0.57 -0.25,0.08 -0.67,-0.22 -0.17,-0.22"
          transform="translate(23, 11.2)"
        />
      </g>
    </>
  ),
  es: (
    <>
      <rect
        fill="#AA151B"
        width="30"
        height="20"
      />
      <rect
        fill="#F1BF00"
        y="5"
        width="30"
        height="10"
      />
    </>
  ),
  us: (
    <>
      <rect
        fill="#FFF"
        width="30"
        height="20"
      />
      <g fill="#B22234">
        <rect
          width="30"
          height="1.54"
        />
        <rect
          y="3.08"
          width="30"
          height="1.54"
        />
        <rect
          y="6.15"
          width="30"
          height="1.54"
        />
        <rect
          y="9.23"
          width="30"
          height="1.54"
        />
        <rect
          y="12.31"
          width="30"
          height="1.54"
        />
        <rect
          y="15.38"
          width="30"
          height="1.54"
        />
        <rect
          y="18.46"
          width="30"
          height="1.54"
        />
      </g>
      <rect
        fill="#3C3B6E"
        width="12"
        height="10.77"
      />
      <g fill="#FFF">
        <circle
          cx="2"
          cy="1.5"
          r=".5"
        />
        <circle
          cx="4.5"
          cy="1.5"
          r=".5"
        />
        <circle
          cx="7"
          cy="1.5"
          r=".5"
        />
        <circle
          cx="9.5"
          cy="1.5"
          r=".5"
        />
        <circle
          cx="3.25"
          cy="3"
          r=".5"
        />
        <circle
          cx="5.75"
          cy="3"
          r=".5"
        />
        <circle
          cx="8.25"
          cy="3"
          r=".5"
        />
        <circle
          cx="2"
          cy="4.5"
          r=".5"
        />
        <circle
          cx="4.5"
          cy="4.5"
          r=".5"
        />
        <circle
          cx="7"
          cy="4.5"
          r=".5"
        />
        <circle
          cx="9.5"
          cy="4.5"
          r=".5"
        />
        <circle
          cx="3.25"
          cy="6"
          r=".5"
        />
        <circle
          cx="5.75"
          cy="6"
          r=".5"
        />
        <circle
          cx="8.25"
          cy="6"
          r=".5"
        />
        <circle
          cx="2"
          cy="7.5"
          r=".5"
        />
        <circle
          cx="4.5"
          cy="7.5"
          r=".5"
        />
        <circle
          cx="7"
          cy="7.5"
          r=".5"
        />
        <circle
          cx="9.5"
          cy="7.5"
          r=".5"
        />
        <circle
          cx="3.25"
          cy="9"
          r=".5"
        />
        <circle
          cx="5.75"
          cy="9"
          r=".5"
        />
        <circle
          cx="8.25"
          cy="9"
          r=".5"
        />
      </g>
    </>
  ),
  cn: (
    <>
      <rect
        fill="#DE2910"
        width="30"
        height="20"
      />
      <g fill="#FFDE00">
        <polygon points="5,1.6 5.59,3.4 7.47,3.4 5.94,4.57 6.53,6.37 5,5.2 3.47,6.37 4.06,4.57 2.53,3.4 4.41,3.4" />
        <polygon points="10.2,1.2 10.44,1.94 11.22,1.94 10.59,2.4 10.83,3.14 10.2,2.68 9.57,3.14 9.81,2.4 9.18,1.94 9.96,1.94" />
        <polygon points="12.2,3.2 12.44,3.94 13.22,3.94 12.59,4.4 12.83,5.14 12.2,4.68 11.57,5.14 11.81,4.4 11.18,3.94 11.96,3.94" />
        <polygon points="12.2,6.2 12.44,6.94 13.22,6.94 12.59,7.4 12.83,8.14 12.2,7.68 11.57,8.14 11.81,7.4 11.18,6.94 11.96,6.94" />
        <polygon points="10.2,8.2 10.44,8.94 11.22,8.94 10.59,9.4 10.83,10.14 10.2,9.68 9.57,10.14 9.81,9.4 9.18,8.94 9.96,8.94" />
      </g>
    </>
  ),
};

const FlagIcon = ({code, size = 20}) => {
  const content = flagPaths[code?.toLowerCase()];
  if (!content) return null;

  const height = Math.round((size * 2) / 3);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 20"
      width={size}
      height={height}
      className={styles.flag}
      role="img"
      aria-label={code?.toUpperCase()}
    >
      {content}
    </svg>
  );
};

export default FlagIcon;
